module.exports = __webpack_public_path__ + "static/img/KO.785fb88.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/KO.png
// module id = dT8D
// module chunks = 1